import React from "react";
import { Link } from "react-router-dom";

export default function BarraTop() {
  return (
    <div className="top">
      <Link to="/">
        <h1>IPB.Comunicação</h1>
      </Link>
    </div>
  );
}
